import React from 'react';
import _ from 'lodash';
import { ExclamationCircleFilled } from '@ant-design/icons';
import type { MessageInstance } from 'antd/es/message/interface';

import { IconSvg } from 'shared/icon';
import { StyledMessageCloseIcon } from 'shared/Common.styled';
import { getRandomNumber } from 'utils/utils';

import type {
  MessagePayload,
  MessageDetails,
} from './types';

const MessageService = {
  message: null as MessageInstance | null,

  setMessage(message: MessageInstance) {
    MessageService.message = message;
  },

  destroy(key?: React.Key) {
    MessageService.message?.destroy(key);
  },

  getMessageDetails(msgContent: MessagePayload | string): MessageDetails {
    const msg = _.isString(msgContent)
      ? msgContent
      : msgContent?.content;

    const key = getRandomNumber();

    return {
      content: (
        <>
          {msg}
          <StyledMessageCloseIcon
            onClick={() => MessageService.destroy(key)}
          >
            <IconSvg
              icon="CloseModalIcon"
              width="12px"
              height="12px"
              color=""
            />
          </StyledMessageCloseIcon>
        </>
      ),
      key,
    };
  },

  error(msgData: MessagePayload) {
    const { content, key } = MessageService.getMessageDetails(msgData);
    const onClose = typeof msgData === 'string' ? undefined : msgData.onClose;

    return MessageService.message?.error({
      content,
      icon: <ExclamationCircleFilled />,
      key,
      onClose,
    });
  },

  success(msgData: MessagePayload) {
    const { content, key } = MessageService.getMessageDetails(msgData);
    const onClose = typeof msgData === 'string' ? undefined : msgData.onClose;

    return MessageService.message?.success({
      content,
      key,
      onClose,
    });
  },
};

export default MessageService;
